import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true })
export default class PanierModule extends VuexModule {
    public count = 0;
    public itemCat = '';

    @Mutation
    public setItemCat(item: string): void {
        this.itemCat = item;
    }

    @Mutation
    public setCount(length: number): void {
        this.count = length;
    }

    @Action({ rawError: true })
    public setCountField(count: number): void {
        this.context.commit('setCount', count);
    }

    @Action({ rawError: true })
    public addProduct(): void {
        this.context.commit('setCount', this.count + 1);
    }

    @Action({ rawError: true })
    public removeProduct(): void {
        this.context.commit('setCount', this.count - 1);
    }

}
